import { toast } from 'react-toast';
import api from 'utils/api';
import axios from "axios";

export const getUsers = (query) => {
	const token = localStorage.getItem('token');
	return new Promise((resolve, reject) => {
		return api
			.post('https://billpay.mtmpay.in/Admin/api/admin/users-list',
				{
					query,
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};
export const getAdminMerchantlist = (query, page, per_page) => {
	return new Promise((resolve, reject) => {
		return api
			.post('/users-list', { params: query, page: page, perPage: per_page })
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

// export const createUser = (data) => {
// 	return new Promise((resolve, reject) => {
// 		return api
// 			.post('/admin/users', data)
// 			.then((response) => {
// 				resolve(response.data);
// 			})
// 			.catch((err) => {
// 				toast.error(err.response.data.message);
// 				reject(err);
// 			});
// 	});
// };
export const createUser = (data) => {
	return new Promise((resolve, reject) => {
		return api.post('/create-user', data)
			.then((response) => {
				toast.success("User created successfully");
				resolve(response.data); // Resolve with the created user data
			})
			.catch((err) => {
				toast.error(err.response?.data?.message || "Failed to create user");
				reject(err); // Reject with the error
			});
	});
};
export const getUser = (id) => {
	return new Promise((resolve, reject) => {
		return api
			.get(`https://billpay.mtmpay.in/Admin/api/admin/users-list${id}`)
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const fetchData1 = (query, page, per_page) => {
	return new Promise((resolve, reject) => {
		return api
			.get('/admin/partner/paypal-transaction-list', {
				params: { ...query, page, per_page }, // Ensure pagination params are passed correctly
			})
			.then((response) => {
				resolve(response.data);
				console.warn(response.data.length)
			})
			.catch((err) => {
				reject(err);
			});
	});
};




// export const updateUser = (id, data) => {
// 	const token = localStorage.getItem('token');
// 	return new Promise((resolve, reject) => {
// 		return api
// 			.post(`https://billpay.mtmpay.in/Admin/api/admin/update-user/${id}`, {
// 				data,
// 				headers: {
// 					Authorization: `Bearer ${token}`,
// 				},
// 			})
// 			.then((response) => {
// 				toast.success('Success');
// 				resolve(response.data);
// 			})
// 			.catch((err) => {
// 				toast.error(err.response.data.message);
// 				reject(err);
// 			});
// 	});
// };

export const updateUser = (id, data) => {
	const token = localStorage.getItem('token');
	return new Promise((resolve, reject) => {
		return api
			.post(`https://billpay.mtmpay.in/Admin/api/admin/update-user/${id}`, data, {

				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((response) => {
				// toast.success('Success');
				resolve(response.data);
			})
			.catch((err) => {
				toast.error(err.response.data.message);
				reject(err);
			});
	});
};




export const deleteUser = (id) => {
	const token = localStorage.getItem('token');
	return new Promise((resolve, reject) => {
		return api
			.post(`https://billpay.mtmpay.in/Admin/api/admin/user-delete/${id}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
			.then((response) => {
				toast.success('Success');
				resolve(response.data);
			})
			.catch((err) => {
				toast.error(err.response.data.message);
				reject(err);
			});
	});
};


export const deleteIPUser = (id) => {
	return new Promise((resolve, reject) => {
		return api
			.delete(`/ip-whitelist-payout-delete/${id}`)
			.then((response) => {
				toast.success('Success');
				resolve(response.data);
			})
			.catch((err) => {
				toast.error(err.response.data.message);
				reject(err);
			});
	});
};

export const assignPermissions = (id, data) => {
	return new Promise((resolve, reject) => {
		return api
			.put(`/admin/users/${id}/permissions`, data)
			.then((response) => {
				toast.success('Success');
				resolve(response.data);
			})
			.catch((err) => {
				toast.error(err.response.data.message);
				reject(err);
			});
	});
};
export const getUserDetails = (id) => {
	return new Promise((resolve, reject) => {
		return api
			.post(
				'https://billpay.mtmpay.in/Admin/api/admin/user-details',
				{ id }
			)
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};


export const getUserLoginHistory = (userId, page = 1) => {
	const token = localStorage.getItem("token");

	return axios.post(
		"https://billpay.mtmpay.in/Admin/api/admin/user-login-history",
		{
			user_id: userId,
			page: page,
		},
		{
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
		}
	);
};

export const assignUsersToParent = (data) => {
	return new Promise((resolve, reject) => {
		return api
			.post(`users/assign`, data)
			.then((response) => {
				toast.success('Success');
				resolve(response.data);
			})
			.catch((err) => {
				toast.error(err.response.data.message);
				reject(err);
			});
	});
};

export const unassignUsersFromParent = (data) => {
	return new Promise((resolve, reject) => {
		return api
			.post(`/admin/users/unassign`, data)
			.then((response) => {
				toast.success('Success');
				resolve(response.data);
			})
			.catch((err) => {
				toast.error(err.response.data.message);
				reject(err);
			});
	});
};

export const getUserStores = (id, query) => {
	return new Promise((resolve, reject) => {
		return api
			.get(`/admin/users/${id}/stores`, { params: query })
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const getUserStore = (userId, id, query) => {
	return new Promise((resolve, reject) => {
		return api
			.get(`/admin/users/${userId}/stores/${id}`, { params: query })
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const fetchUserAccessToken = (userId) => {
	return new Promise((resolve, reject) => {
		return api
			.post(`/admin/users/${userId}/access-token`)
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};



/**
 * User API
 */

export const getPartners = (query) => {
	return new Promise((resolve, reject) => {
		return api
			.post('/distributor-list', { params: query })
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};


export const getManager = (query, page, per_page) => {
	// alert('ppppp');
	return new Promise((resolve, reject) => {
		return api
			.post('/merchant-list', { params: query, page: page, perPage: per_page })
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const getRate = (query, page, per_page) => {
	// alert('ppppp');
	return new Promise((resolve, reject) => {
		return api
			.post('rate-commission-list', { query, page: page, perPage: per_page })
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};


export const role_and_permission_list = (query, page, per_page) => {
	// alert('ppppp');
	return new Promise((resolve, reject) => {
		return api
			.post('role_and_permission_list', { query, page: page, perPage: per_page })
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const partnermanagerlistadmin = (query, page, per_page) => {
	// alert('ppppp');
	return new Promise((resolve, reject) => {
		return api
			.get('admin/admin-ledger-report/partner-manager-list-admin', { params: query, page: page, perPage: per_page })
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};


export const getPartner = (id) => {
	return new Promise((resolve, reject) => {
		return api
			.get(`/admin/partner/ListUserPayinChargeByAdmin/${id}`)
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};


export const getMerchantCommision = (id) => {
	return new Promise((resolve, reject) => {
		return api
			.post(`/admin/partner/ListUserPayinChargeByAdmin/${id}`)
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};



export const getManagerParnter = (id) => {
	const segment = window.location.pathname.split("/");

	return new Promise((resolve, reject) => {
		return api
			.get(`/manager/merchant/partners/${segment[2]}`)
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const updatePartner = (id, data) => {
	return new Promise((resolve, reject) => {
		return api
			.put(`/user-change-status/${id}`, data)
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};


export const updatePartnerPayinPayout = (id) => {

	return new Promise((resolve, reject) => {
		return api
			.post(`/manager/partners/payinpayout`, id)
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};
export const partnerpayoutpayinpermission = (id) => {

	return new Promise((resolve, reject) => {
		return api
			.post(`/manager/summary/partner-payin-permission`, id)
			.then((response) => {
				resolve(response.data);
				getManager();
				console.warn(response);
			})
			.catch((err) => {
				reject(err);
			});
	});
};
export const partnerpayoutpayoutpermission = (id) => {

	return new Promise((resolve, reject) => {
		return api
			.post(`/manager/summary/partner-payout-permission`, id)
			.then((response) => {
				resolve(response.data);
				getManager();
				console.warn(response);
			})
			.catch((err) => {
				reject(err);
			});
	});
};
export const partnerPaypalpermission = (id) => {

	return new Promise((resolve, reject) => {
		return api
			.post(`/manager/summary/partner-paypal-permission`, id)
			.then((response) => {
				resolve(response.data);
				getManager();
				console.warn(response);
			})
			.catch((err) => {
				reject(err);
			});
	});
};


export const paymentmode = (payload) => {
	return new Promise((resolve, reject) => {
		return api
			.post(`/admin/permission_management/payment-mode-permission-set`, payload)
			.then((response) => {
				resolve(response.data);
				getManager();
				console.warn(response);
			})
			.catch((err) => {
				reject(err);
			});
	});
};


export const getUsersOfPartner = (partnerId, query) => {
	return new Promise((resolve, reject) => {
		return api
			.get(`/manager/partners/${partnerId}`, { params: query })
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const updateUserOfPartner = (partnerId, userId, data) => {
	return new Promise((resolve, reject) => {
		const payload = {
			...data,
			user_id: userId
		};
		api
			.post(`update-rate-commission`, payload)
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const updateMerchanatLimit = (id, data) => {
	return new Promise((resolve, reject) => {
		return api
			.put(`https://billpay.mtmpay.in/Admin/api/admin/merchant-commission-update/${id}`, data)
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};


export const onboardUsersOfPartner = (partnerId, data) => {
	return new Promise((resolve, reject) => {
		return api
			.post(`/manager/partners/${partnerId}/users/onboarding`, data)
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const getSubUsers = (query) => {
	return new Promise((resolve, reject) => {
		return api
			.get('/manager/users', { params: query })
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const updatemerchantordersdata = (id) => {
	return new Promise((resolve, reject) => {
		return api
			.post(`/update-merchant-orders-data`, id)
			.then((response) => {
				resolve(response.data);
				getManager();
				console.warn(response);
			})
			.catch((err) => {
				reject(err);
			});
	});
};